/**
 * Special options passed to TreeRepository#findTrees
 */
export interface FindTreesOptions {
    /**
     * When loading a tree from a TreeRepository, limits the depth of the descendents loaded
     */
    depth?: number
}
